import React, { Component } from "react";

export default class ErrorPage extends Component {
  render() {
    return (
      <div>
        <h1>404 page not found</h1>
      </div>
    );
  }
}
